export default __webpack_public_path__ + "static/download-qr-57a51ca7ca0d8c91d8955e5a87d28cad.svg";